import { Reducer } from "redux";

import { MasterDocumentNoteResponse } from "../models/api/Master";
import { MasterDocumentNoteDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterDocumentNoteActionDispatchTypes } from "../constants/Master";

const initialState: MasterDocumentNoteResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterDocumentNoteReducer: Reducer<
  MasterDocumentNoteResponse,
  MasterDocumentNoteDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterDocumentNoteActionDispatchTypes.MASTER_DOCUMENT_NOTE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterDocumentNoteActionDispatchTypes.MASTER_DOCUMENT_NOTE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterDocumentNoteActionDispatchTypes.MASTER_DOCUMENT_NOTE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterDocumentNoteReducer;
